import { render, staticRenderFns } from "./Politics.vue?vue&type=template&id=49579f62"
import script from "./Politics.vue?vue&type=script&lang=js"
export * from "./Politics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports